<template>
  <commonQueryInput
    :inputItems="multiInputItems"
    :buttonHide="true"
    v-model:getValue="multiInputVal"
  ></commonQueryInput>
  <div class="d-flex justify-content-end text-end">
    <div class="py-1 px-2" style="background: #c8c9ca; min-width: max-content">
      <span>報修人員：{{ username }}</span>
    </div>
  </div>
  <div class="text-start mb-3" style="font-size: 18px">
    <span>異常描述：</span>
    <!-- <label for="floatingTextarea">描述</label> -->
    <div class="form-floating">
      <textarea
        class="form-control p-2"
        placeholder="Leave a comment here"
        id="floatingTextarea"
        style="height: 200px"
        v-model="textData"
      ></textarea>
    </div>
  </div>
  <div class="gap-2 d-md-flex justify-content-md-end">
    <button
      type="button"
      class="btn p-0 me-2"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="cancelAdd"
    >
      取消
    </button>
    <button
      type="button"
      class="btn p-0"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="checkAdd(multiInputItems, multiInputVal, textData)"
    >
      確認
    </button>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput";
import commonSelectInput from "@/components/commonQueryInput/commonSelectInput";
import { computed, inject, ref } from "vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
    commonSelectInput,
  },
  setup() {
    const add = inject("add");
    const commonMethods = inject("commonMethods");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const repairOper = computed(() => store.getters["selectOptions/get_repairOper"]);
    const repairDevice = computed(() => store.getters["selectOptions/get_repairDevice"]);

    const checkAdd = commonMethods.checkAdd;
    const cancelAdd = commonMethods.cancelAdd;

    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "oper",
        label: "站別",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇站別 --",
        options: repairOper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: true,
        disableText: "-- 選擇機台 --",
        bindOptions: repairDevice,
      },
    ]);

    const textData = ref("");
    const addMatch = ref(null);

    // let validationTimeout = null; //密碼檢查逾時計時器

    // const validateSchedule = () => {
    //   console.log(multiInputVal.value)
    //   console.log(textData.value)
    //   //   if (newPassword.value == "" || checkNewPassword.value == "") {
    //   //     return;
    //   //   }
    //   //   if (newPassword.value === checkNewPassword.value) {
    //   //     addMatch.value = true;
    //   //   } else {
    //   //     addMatch.value = false;
    //   //   }
    // };
    // const scheduleValidation = () => {
    //   if (validationTimeout) {
    //     clearTimeout(validationTimeout);
    //   }

    //   validationTimeout = setTimeout(() => {
    //     validateSchedule();
    //   }, 500);
    // };

    // watch(
    //   [multiInputVal, textData],
    //   () => {
    //     scheduleValidation();
    //   },
    //   { deep: true }
    // );

    return {
      add,
      multiInputVal,
      multiInputItems,
      textData,
      checkAdd,
      cancelAdd,
      account,
      username,
      addMatch,
      // validateSchedule,
    };
  },
};
</script>

<style></style>
